
<template>

	<div>

		<window_portal v-if="x_attr && y_attr" v-model="open_modal" :title="x_attr.name + ' - ' + y_attr.name + ' (' + plot_type + ')'" v-slot="modal_ref">
			<div class="p-2">
				<v-context-menu ref="plot_type_context_menu_window">
	
					<b-dropdown-item v-for="_plot_type in plot_types" :key="_plot_type" v-on:click="(ev) => set_plot_type(_plot_type, true, ev)">{{ _plot_type }}<span v-if="plot_type == _plot_type">&#10004;&nbsp;</span></b-dropdown-item>
	
				</v-context-menu>
	
				<div class="d-flex justify-content-between">

					
				</div>
				<div class="btn_group mt-2">
	
					<b-button v-if="check_roles([ 'model' ])" size="sm" variant="outline-primary" data-tooltip="Отмена последнего действия" v-on:click="() => $emit('bring_back')"><base-icon name="actions_undo" style="pointer-events: none" /></b-button>
	
					<b-button v-if="check_roles([ 'model' ])" size="sm" variant="outline-primary" data-tooltip="Вернуть в исходное состояние" v-on:click="reset_state"><base-icon name="broomstick" style="pointer-events: none" /></b-button>

					<b-button v-if="hide_bad" size="sm" variant="outline-primary" data-tooltip="Отобразить все" v-on:click="() => set_plot_type('Все')"><base-icon name="blowout_close" style="pointer-events: none" /></b-button>
					<b-button v-if="! hide_bad" size="sm" variant="outline-primary" data-tooltip="Скрыть выбросы" class="filter-button" v-on:click="() => set_plot_type('Не выбросы')"><base-icon name="blowout_open" style="pointer-events: none" /></b-button>
	
					<b-button v-if="check_roles([ 'model' ])" size="sm" :variant="(set_selected ? '' :'outline-') + 'primary'" data-tooltip="Лассо - выбор" v-on:click="() => { set_selected = ! set_selected }"><base-icon name="lasso" style="pointer-events: none" /></b-button>

					<b-button v-if="check_roles([ 'model' ])" size="sm" variant="outline-primary" data-tooltip="Сбросить выбор" v-on:click="reset_selected"><base-icon name="lasso_off" style="pointer-events: none" /></b-button>

					<!-- <b-button v-if="check_roles([ 'model' ])" variant="outline-primary" v-b-tooltip:fullscreen.hover.bottomright="'Перевод объектов-аналогов в выбросы (Shift + Space)'" v-on:click="() => set_state_for_selected(false)"><b-icon-arrow-right-circle /></b-button>
					<b-button v-if="check_roles([ 'model' ])" variant="outline-primary" v-b-tooltip:fullscreen.hover.bottomright="'Перевод из выбросов в модель (Ctrl + Space)'" v-on:click="() => set_state_for_selected(true)"><b-icon-arrow-left-circle /></b-button> -->
	
				</div>
	
				<div align="center">
	
					<scatter_plot ref="plot" class="mt-2"
						:plot_id="plot_id + '_modal'" :plot_type="plot_type" :set_selected="set_selected" :x_attr="x_attr" :y_attr="y_attr"
						v-on:context_menu="plot_type_context_menu_window" is_modal :modal_ref="modal_ref" />
	
				</div>
				
				<b-row>
	
					<b-col cols="3">Общее количество ОА - {{ objects_count }}</b-col><!--style="padding:0"-->
					<b-col cols="4"><!--style="padding:0"-->
						<span :id="'good_' + plot_id" style="width: 20px; height: 20px;"/>
						Количество ОА, участвующих в расчете - {{ good_count }}
					</b-col>
					<b-col cols="5"><!--style="padding:0"-->
						<span :id="'bad_' + plot_id" style="width: 20px; height: 20px;"/>
						Количество ОА, не участвующих в расчете - {{ bad_count }}
					</b-col>
	
				</b-row>
	
				<div class="mt-2">
	
					<b-row align-v="center">
	
						<b-col cols="2" align="right">Ось Y</b-col>
						<b-col><v-select v-model="y_id" :options="showed_attrs" label="name" :reduce="obj => obj.id" v-on:input="id => $emit('y_changed', id)" clearSearchOnSelect required appendToBody appendToParent/></b-col>
	
					</b-row>
	
				</div>
	
				<div class="mt-2">
	
					<b-row align-v="center">
	
						<b-col cols="2" align="right">Ось X</b-col>
						<b-col><v-select v-model="x_id" :options="showed_attrs" label="name" :reduce="obj => obj.id" v-on:input="id => $emit('x_changed', id)" clearSearchOnSelect required appendToBody appendToParent/></b-col>
	
					</b-row>
	
				</div>
			</div>
		</window_portal>

		<v-context-menu ref="plot_type_context_menu">

			<b-dropdown-item v-for="_plot_type in plot_types" :key="_plot_type" v-on:click="() => set_plot_type(_plot_type)">{{ _plot_type }}<span v-if="plot_type == _plot_type">&#10004;&nbsp;</span></b-dropdown-item>

		</v-context-menu>

		<div class="d-flex justify-content-between align-items-center">

			<div class="btn_group">
				<!--<b-button size="sm" variant="outline-primary" v-b-tooltip:fullscreen.hover.bottomright="'Экспорт моделей'" v-on:click="() => $emit('export_models')"><b-icon-clipboard-data/></b-button>-->
				<b-button v-if="check_roles([ 'model' ])" size="sm" variant="outline-primary" v-b-tooltip:fullscreen.hover.bottomright="'Отмена последнего действия (Ctrl + Z)'" v-on:click="() => $emit('bring_back')"><base-icon name="actions_undo" /></b-button>
	
				<b-button v-if="check_roles([ 'model' ])" size="sm" variant="outline-primary" v-b-tooltip:fullscreen.hover.bottomright="'Вернуть в исходное состояние'" v-on:click="reset_state"><base-icon name="broomstick" /></b-button>
				<b-button v-if="hide_bad" size="sm" variant="outline-primary" v-b-tooltip:fullscreen.hover.bottomright="'Отобразить все'" v-on:click="() => set_plot_type('Все')"><base-icon name="blowout_close" /></b-button>
				<b-button v-if="! hide_bad" size="sm" variant="outline-primary" v-b-tooltip:fullscreen.hover.bottomright="'Скрыть выбросы'" v-on:click="() => set_plot_type('Не выбросы')"><base-icon name="blowout_open" /></b-button>
	
				<b-button v-if="check_roles([ 'model' ])" size="sm" :variant="(set_selected ? '' :'outline-') + 'primary'" v-b-tooltip:fullscreen.hover.bottomright="'Лассо - выбор'" v-on:click="() => { set_selected = ! set_selected }"><base-icon name="lasso" /></b-button>
				<b-button v-if="check_roles([ 'model' ])" size="sm" variant="outline-primary" v-b-tooltip:fullscreen.hover.bottomright="'Сбросить выбор'" v-on:click="reset_selected"><base-icon name="lasso_off" /></b-button>

				<!-- <b-button v-if="check_roles([ 'model' ])" variant="outline-primary" v-b-tooltip:fullscreen.hover.bottomright="'Перевод объектов-аналогов в выбросы (Shift + Space)'" v-on:click="() => set_state_for_selected(false)"><b-icon-arrow-right-circle /></b-button>
				<b-button v-if="check_roles([ 'model' ])" variant="outline-primary" v-b-tooltip:fullscreen.hover.bottomright="'Перевод из выбросов в модель (Ctrl + Space)'" v-on:click="() => set_state_for_selected(true)"><b-icon-arrow-left-circle /></b-button> -->
				
			</div>

			<div class="btn_group">
				<b-button size="sm" class="transparent" v-b-tooltip:fullscreen.hover.bottomright title="Дублировать окна" v-on:click="() => $emit('add_plot')"><base-icon name="dublicate_window" /></b-button>
				
				<b-button size="sm" class="transparent" v-b-tooltip:fullscreen.hover.bottomright="'Открыть в окне'" v-on:click="() => open_modal = !open_modal"><base-icon name="Full - Short_open" /></b-button>
				
				<b-button v-if="! last_plot" size="sm" class="transparent" v-b-tooltip:fullscreen.hover.bottomright="'Закрыть'" v-on:click="() => $emit('delete_plot')"><base-icon name="clear" /></b-button>
			</div>
		</div>


		<div align="center">

			<scatter_plot ref="plot" class="mt-2"
				:plot_id="plot_id" :plot_type="plot_type" :set_selected="set_selected" :x_attr="x_attr" :y_attr="y_attr"
				v-on:context_menu="plot_type_context_menu"/>

		</div>

		<!-- <b-row class="mt-2 w-100" align-v="center">

			<b-col cols="2" align="right">Корреляция</b-col>
			<b-col cols="1">{{ correlation }}</b-col>
			<b-col cols="9" style="padding:0">

				
			</b-col>
			
		</b-row> -->
		<b-row>

			<b-col cols="3">Общее количество ОА - {{ objects_count }}</b-col><!--style="padding:0"-->
			<b-col cols="4"><!--style="padding:0"-->
				<span :id="'good_' + plot_id" style="width: 20px; height: 20px;"/>
				Количество ОА, участвующих в расчете - {{ good_count }}
			</b-col>
			<b-col cols="5"><!--style="padding:0"-->
				<span :id="'bad_' + plot_id" style="width: 20px; height: 20px;"/>
				Количество ОА, не участвующих в расчете - {{ bad_count }}
			</b-col>

		</b-row>

		<div class="mt-2">

			<b-row align-v="center">

				<b-col cols="2" align="right">Ось Y</b-col>
				<b-col><v-select v-model="y_id" :options="showed_attrs" label="name" :reduce="obj => obj.id" v-on:input="id => $emit('y_changed', id)" clearSearchOnSelect required/></b-col>

			</b-row>

		</div>

		<div class="mt-2">

			<b-row align-v="center">

				<b-col cols="2" align="right">Ось X</b-col>
				<b-col><v-select v-model="x_id" :options="showed_attrs" label="name" :reduce="obj => obj.id" v-on:input="id => $emit('x_changed', id)" clearSearchOnSelect required/></b-col>

			</b-row>

		</div>

	</div>

</template>

<script>

import * as d3 from "d3"
import api from "../../../../../../api"
import { bus } from "../../../../../../api/bus"
import o from "./../objects"
import scatter_plot from "./scatter_plot"
import window_portal from "../../../../../widgets/window_portal"

export default
{
	props :
	{
		id : String,
		plot_id : String,
		attrs : Array,
		last_plot : Boolean,
		initial_x : String,
		initial_y : String,
	},

	components :
	{
		scatter_plot,
		window_portal,
	},

	watch :
	{
		attrs :
		{
			immediate : true,
			deep : true,

			handler(attrs)
			{
				if(attrs && attrs.length)
				{
					if(this.x_id == null && this.y_id == null)
					{
						this.y_id = attrs[0].id
						this.x_id = null

						this.$emit("y_changed", this.y_id)
					}
					else
					{
						if(attrs.find(attr => attr.id == this.x_id) == null)
							this.x_id = null

						if(attrs.find(attr => attr.id == this.y_id) == null)
							this.y_id = null
					}

					var showed_attrs = []

					attrs.forEach(
						attr =>
						{
							if(showed_attrs.findIndex(_attr => _attr.id == attr.id) == -1)
								showed_attrs.push(attr)
						})

					this.showed_attrs = showed_attrs
				}

				this.refresh()
			}
		},

		initial_x :
		{
			immediate : true,
			handler(initial_x)
			{
				if(initial_x)
				{
					this.x_id = initial_x
					this.refresh()
				}
			}
		},

		initial_y :
		{
			immediate : true,
			handler(initial_y)
			{
				if(initial_y)
				{
					this.y_id = initial_y
					this.refresh()
				}
			}
		},
	},

	data()
	{
		return {

			correlation : null,

			set_selected : false,

			showed_attrs : [],
			x_attr : null,
			y_attr : null,

			objects_count : null,
			good_count : null,
			bad_count : null,
			hide_bad : false,

			plot_type : "Все",
			plot_types : [ "Все", "Обучающая выборка", "Контрольная выборка" ],

			open_modal : false,

		}
	},

	mounted()
	{
		this.good_count = o.objects().good_count
		this.bad_count = o.objects().bad_count
		this.objects_count = o.objects().count

		bus.$on("set_plot_type",
			ev =>
			{
				this.plot_type = ev.plot_type
				this.hide_bad = ev.plot_type != "Все"
			})

		o.objects().bus.$on("update_plots",
			() =>
			{
				o.objects().correlation(this.x_attr, this.y_attr).then(correlation => { this.correlation = correlation })
				this.good_count = o.objects().good_count
				this.bad_count = o.objects().bad_count
				this.objects_count = o.objects().count
			})

		d3.select("#good_" + this.plot_id)
			.append("svg").attr("width", 20).attr("height", 20)
			.append("rect")
			.attr("width", 8)
			.attr("height", 16)
			.attr("rx", 4)
			.style("fill", "var(--bft-blue-500)")

		const bad_symbol = d3.symbol().type(d3.symbolCross).size(75)

		d3.select("#bad_" + this.plot_id)
			.append("svg").attr("width", 20).attr("height", 20)
			.append("path").attr("d", bad_symbol).attr("transform", "translate(10, 10) rotate(45)").style("fill", "var(--bft-natural-900)")
	},

	methods :
	{
		refresh(x_id = null, y_id = null)
		{
			if(x_id == null)
				x_id = this.x_id

			if(y_id == null)
				y_id = this.y_id

			if(x_id != null)
				this.x_attr = this.attrs.find(attr => attr.id == x_id)

			if( y_id != null )
				this.y_attr = this.attrs.find(attr => attr.id == y_id)

			if(! ( x_id == null || y_id == null) )
			{
				api.call(this, "cadastral_cost_evaluation", "set_field", { id : this.id, field : `modeling.pair_plots.${this.plot_id}`, value : { x : x_id, y : y_id } }, () => {})

				o.objects().correlation(this.x_attr, this.y_attr).then(correlation => { this.correlation = correlation })
			}
		},

		check_roles(roles)
		{
			return api.check_roles(this, roles)
		},

		reset_selected()
		{
			o.objects().reset_selected()
		},

		reset_state()
		{
			o.objects().reset_state()
		},

		set_state_for_selected(state)
		{
			bus.$emit("modeling:set_state_for_selected", state)
		},


		plot_type_context_menu_window(ev)
		{
			ev.preventDefault()
			this.$refs.plot_type_context_menu_window.open(ev)
		},

		plot_type_context_menu(ev)
		{
			ev.preventDefault()
			this.$refs.plot_type_context_menu.open(ev)
		},

		set_plot_type(plot_type, is_modal=false, ev)
		{
			if (is_modal) ev.preventDefault()
			this.plot_type = plot_type

			bus.$emit("set_plot_type", { plot_type : plot_type })
		},
	}
}

</script>
